<template>
    <div class="container">
        <div class="content_top">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>参与项目</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="research-title">
            PUBLICATIONS
        </div>
        <div class="project-words" v-for="(item, idx) in projectDataList">
            {{ idx + 1 }}.{{ item.english }}
            <br />
            {{ item.chinese }}
        </div>
    </div>
</template>

<script>
import requests from "@/api/request";
export default {
    name: "ProjectView",
    data() {
        return {
            projectDataList: []
        }
    },
    mounted() {
        this.getProjectDataList();
    },
    methods: {
        async getProjectDataList() {
            return requests({
                url: "/projects/showProjects",
                method: "GET"
            }).then(res => {
                console.log('getMemberList', res.data);
                this.projectDataList.splice(0, this.projectDataList.length);
                let d = res.data
                d.forEach((item, i) => {
                    this.projectDataList.push(d[i]);
                    // this.$set(this.memberList[i], 'date', d[i].createTime.substring(0,10));
                });
                // console.log('this.NewsList',this.NewsList);
            }).catch(err => {
                console.log('error', err)
                this.$message({
                    showClose: true,
                    message: err.message,
                    type: 'error'
                });
            });
        },
    }
}
</script>

<style scoped>
.container {
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 30px;
}

.content_top {
    margin: 20px 0;
}

.research-title {
    margin-top: 10px;
    margin-bottom: 20px;
    color: #63065F;
    font-size: 24px;
    font-family: "ArialMT";
}

.project-words {
    color: #233;
    font-size: 15px;
    font-weight: 400;
    margin-top: 8px;
    line-height: 1.6em;
    text-align: justify;
}
</style>